<div class="create-survey-wrapper w-full hidden sm:flex sm:flex-col">
  <div class="w-full">
    <div class="title-wrapper w-full flex justify-center">
      <div class="title-section w-full">
        <div class="title-content">
          {{surveyDetails?.title}}
        </div>
        <div class="description-content">
          {{surveyDetails?.description}}
        </div>
      </div>
    </div>
  </div>
  <div class="form-wrapper w-full">
    <div *ngIf="!editMode"
         class="py-0 px-0 sm:py-10 sm:px-8 w-full">
      <div *ngFor="let question of formData.elements;let index=index">
        <div [class.question-gap]="index>0">
          <div class="question-name">
            {{question?.title ? question?.title : question?.name}}
          </div>
          <div class="flex justify-between question-section-wrapper">
            <div *ngIf="!question?.choices"
                 class="w-[100%] question-text-wrapper flex items-center">
              {{''}}
            </div>
          </div>
          <div>
            <div *ngIf="question?.choices && question?.choices?.length>0"
                 class="choice-name">
              {{'Choices'}}
            </div>
            <div *ngFor="let choice of question.choices">
              <div class="options-text-wrapper w-full">
                {{choice?.text ? choice?.text : choice}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-button-section w-full flex justify-end">
        <app-primary-button (handleClick)="onEditButtonClicked()"
                            *ngIf="!(surveyDetails?.status?.key === 3) &&
                            !(surveyDetails?.respondentsCount >0) && !loading
                             && !groupId && !clientId"
                            [type]="'small'"
                            class="w-full md:w-[20%]">Edit
        </app-primary-button>
      </div>
    </div>
    <div *ngIf="editMode"
         class="py-0 px-0 sm:py-10 sm:px-8 w-full">
      <div class="w-full">
        <survey-creator [model]="surveyCreatorModel"></survey-creator>
      </div>
      <div class="edit-button-section w-full flex justify-end">
        <app-primary-button (handleClick)="onEditButtonClicked()"
                            [isDisabled]="!(surveyCreatorModel?.JSON?.pages
                            && surveyCreatorModel?.JSON?.pages[0] && surveyCreatorModel?.JSON?.pages[0].elements?.length > 0)"
                            [type]="'small'"
                            class="w-full md:w-[20%]">Save
        </app-primary-button>
      </div>
    </div>
  </div>
</div>
